module.exports = __webpack_public_path__ + "img/tea-time-8100595_1280.7fa44bff.jpg";